module.exports = __webpack_public_path__ + "img/xujing.5f153b12.jpg";